import { FleContinueWrapper, FleLayout } from "components/views/fle/FleLayout"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { IlloFinancial } from "components/views/atoms/Illustrations"
import { LeftArrowAndSpace, ContinueArrow, SpacerSwitcher, SwitchH1ToH2 } from "components/views/fle/Molecules"
import { Body } from "components/views/atoms/Bodies"
import React from "react"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const FinancialSupport = ({
  companyName,
  coverageAmount,
  coveragePercent,
  currencySymbol,
  onBack,
  onComplete
}) => (
  <FleLayout
    bottomContent={
      <FleContinueWrapper>
        <ContinueArrow onClick={onComplete} />
      </FleContinueWrapper>
    }
  >
    <LeftArrowAndSpace onBack={onBack} />
    <div className="no-pointer-events">
      <FlexRowCenter>
        <IlloFinancial />
      </FlexRowCenter>
    </div>
    <SpacerSwitcher />
    <SwitchH1ToH2>Get financial support for your&nbsp;journey</SwitchH1ToH2>
    <Spacer height={0.5} />
    <Body color="black-80">
      Thanks to {companyName}, your benefit covers {coveragePercent}% for the cost of eligible care, up to{" "}
      {currencySymbol}
      {coverageAmount ? coverageAmount.toLocaleString() : ""}.
    </Body>
    <Spacer height={0.5} />
    <Body color="black-80">
      {l`You can use your funds toward family-forming expenses from eligible Carrot providers.`}
    </Body>
    <Spacer height={0.5} />
    <Body color="black-80">
      {l`Be aware that Carrot funds you utilize may be considered additional income and taxed as such, depending on your employer, where you live, and what kind of care you receive.`}
    </Body>
  </FleLayout>
)
